import { LoyaltyApi } from "@smartrr/shared/interfaces/loyalty/api";
import React from "react";

import { useCloseModal } from "@customer-app/state/actionCreators/modal";

import { RedeemIncentiveUnpause } from "./RedeemIncentiveUnpause";
import { LoyaltyStoreAccess } from "../../../store";
import { usePurchaseStates } from "@customer-app/account/views/OperationAquarius/AquariusInner/hooks/usePurchaseStates";
import { getNearestUnpauseDate } from "../../../utils";
import { RedeemIncentiveDelivery } from "./RedeemIncentiveDelivery";
import { RedeemIncentiveOTP } from "./RedeemIncentiveOTP";

export interface RedeemIncentiveModalProps {
  incentive: LoyaltyApi.Incentive.Type;
}

export const RedeemIncentiveModal = ({ incentive }: RedeemIncentiveModalProps) => {
  const upcomingOrder = LoyaltyStoreAccess.useOrder();
  const isOTPEnabled = LoyaltyStoreAccess.useIsOtpEnabled();
  const purchaseStates = usePurchaseStates();

  const allInactive = purchaseStates.every(
    purchaseState =>
      purchaseState.purchaseStateStatus === "PAUSED" || purchaseState.purchaseStateStatus === "CANCELLED"
  );

  const pausedPurchaseStates = purchaseStates.filter(
    purchaseState => purchaseState.purchaseStateStatus === "PAUSED"
  );

  const nearestPurchaseStateWithUnpauseDate = getNearestUnpauseDate(pausedPurchaseStates);

  const closeModal = useCloseModal();

  if (allInactive && nearestPurchaseStateWithUnpauseDate && !isOTPEnabled) {
    return (
      <RedeemIncentiveUnpause
        incentive={incentive}
        purchaseState={nearestPurchaseStateWithUnpauseDate}
        closeIncentivesModal={closeModal}
      />
    );
  }

  if (upcomingOrder) {
    return (
      <RedeemIncentiveDelivery
        upcomingOrder={upcomingOrder}
        incentive={incentive}
        closeIncentivesModal={closeModal}
      />
    );
  }

  return <RedeemIncentiveOTP incentive={incentive} closeIncentivesModal={closeModal} />;
};
